<!-- <section [id]="pageData.scrollId" class="bloque-quienes-somos container-1">
    <div class="container p-5">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 content">
                <div class="section-title mt-5">
                    <h1>¿Quienes somos?</h1>
                    <p class="subtitle mt-3">
                        <b>
                        Somos la Asociación Civil Cannábica Olas Verdes, una organización sin fines de lucro dedicada a promover el uso responsable y medicinal del cannabis. Nuestro objetivo principal es informar, concientizar y ayudar a pacientes que buscan mejorar su calidad de vida a través de los beneficios terapéuticos que ofrece el cannabis medicinal.
                        </b> 
                    </p>
                </div>  
            </div>
        </div> 

        <div class="row mt-5">
            <div class="col-lg-3 col-md-6 col-sm-5">
                <div class="cta-image">
                    <img [src]="rutaImagenUno" class="rounded" alt="...">
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="cta-image">
                    <img [src]="rutaImagenDos" class="rounded" alt="...">
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="cta-image">
                    <img [src]="rutaImagenDos" class="rounded" alt="...">
                </div>
            </div>
        </div>
    </div>

</section> -->


<section id="quienes-somos" class="bloque-quienes-somos container-1" style="position: relative;">
    <div class="container p-5">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 content">
          <div class="section-title mt-5">
            <h1>¿Quiénes somos?</h1>
            <p class="subtitle mt-3">
              <b>
                Somos la Asociación Civil Cannábica Olas Verdes, una organización sin fines de lucro dedicada a promover el uso responsable y medicinal del cannabis. Nuestro objetivo principal es informar, concientizar y ayudar a pacientes que buscan mejorar su calidad de vida a través de los beneficios terapéuticos que ofrece el cannabis medicinal.
              </b>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Efecto de olas -->
    <div class="waves">
      <div class="wave circulo a"></div>
      <div class="wave circulo b"></div>
      <div class="wave circulo c"></div>
    </div>
  </section>
  